/ <template>
    <card-seplag titulo="Manter Ciclo de Recadastramento" cor="#00acc1" >
        <div class="p-col-12">              
            <Fieldset legend="Ciclo">
                <div class="p-grid p-fluid">      
                    <Rotulo nome="Descrição:" cols='12 4' >
                        <InputText type="text" v-model="cicloRecadastramento.descCiclo"  />
                    </Rotulo>              
                    <Rotulo nome="Data Inicio:" cols='12 3' :requerido='true'>
                        <input type="text" class="input-date" name="date" v-model="cicloRecadastramento.dataInicio" v-mask-date.br />          
                    </Rotulo>     
                    <Rotulo nome="Data Fim:" cols='12 3' :requerido='true'>
                        <input type="text" class="input-date" name="date" v-model="cicloRecadastramento.dataFinal" v-mask-date.br />            
                    </Rotulo>
                </div>
            </Fieldset>
        </div>
        <div class="p-col-12">              
            <Fieldset legend="Exercícios">
                <div class="p-col-12 p-md-8 p-md-offset-2">
                    <DataTable :value="exercicios" :paginator='true' :totalRegistro='exercicios.length' :rows="10">  
                        <Column bodyStyle="text-align: center" header="#" :headerStyle="'width: 8em'">
                            <template #body="slotProps">                                     
                                <RadioButton :id="slotProps.data.idenExercicio" :name="slotProps.data.ano" :value="slotProps.data" v-model="cicloRecadastramento.exercicio" />
                            </template>
                        </Column>
                        <Column header="Ano">
                            <template #body="slotProps">                                     
                                    <span class="customer-badge-pentende"> {{slotProps.data.ano}}</span>
                            </template>
                        </Column>    
                    </DataTable >
                </div>
            </Fieldset>
        </div>
        <div class="p-col-12">              
            <Fieldset legend="Termos">
                <div class="p-col-12 p-md-3 p-md-offset-7">                    
                    <Button label="Novo Termo" icon="pi pi-check" class="p-button-rounded" @click="abrirNovoTermo()"/>
                </div>
                <div class="p-col-12 p-md-8 p-md-offset-2">
                    <table-seplag :dados.sync="termos" :exibirCabecalho="false" 
                    :paginacao="true" :loading="loadingPaginacaoTermo" :totalRegistro.sync="totalRegistroTermo" :urlPanagicao="urlPanagicaoTermo">  
                        <Column bodyStyle="text-align: center" header="#" :headerStyle="'width: 8em'">
                            <template #body="slotProps">                                     
                                <RadioButton :id="slotProps.data.idenTermo" :name="slotProps.data.descTermo" :value="slotProps.data" v-model="cicloRecadastramento.termo" />
                            </template>
                        </Column>
                        <Column bodyStyle="text-align: center" header="Descrição" :headerStyle="'width: 6em'">
                            <template #body="slotProps">                                     
                                    <span class="customer-badge-pentende"> {{slotProps.data.descTermo}}</span>
                            </template>
                        </Column>  
                        <Column bodyStyle="text-align: center" header="Data Inicio" :headerStyle="'width: 9em'">
                            <template #body="slotProps">                                     
                                    <span class="customer-badge-pentende"> {{slotProps.data.dataInicioTermo}}</span>
                            </template>
                        </Column>  
                        <Column bodyStyle="text-align: center" header="Data Fim" :headerStyle="'width: 10em'">
                            <template #body="slotProps">                                     
                                    <span class="customer-badge-pentende"> {{slotProps.data.dataTerminoTermo}}</span>
                            </template>
                        </Column>
                            <Column bodyStyle="text-align: center"  :headerStyle="'width: 7.5em'">  
                          <template #body="slotProps"> 
                                    <Button v-tooltip="'Editar'" icon="pi pi-pencil" class="p-button-rounded p-button-warning margin-botao" @click="abrirEditarTermo(slotProps.data)"/>
                                                          
                         
                      
                                    <Button
                                v-tooltip="'excluir Termo'"
                                icon="pi pi-trash"
                                class="p-button-rounded p-button-danger margin-botao"
                               @click="abrirExcluirTermo(slotProps.data)"
              /> 
                        </template> 
                          </Column>
                    </table-seplag>
                </div>               
                
                <!-- MODAL NOVO TERMO -->
                <cadastro-rapido tituloTela="Novo Termo" tamanhoTela="800" v-model="exibirNovoTermo" 
                :modoEdicao="'adicionar'"  :onAdicionar="criarNovoTermo">
                    <div class='p-grid p-fluid'>
                        <Rotulo nome="Descrição:" cols="12" >
                            <InputText type="text" v-model="novoTermo.descTermo" v-required  />
                        </Rotulo>
                        <Rotulo nome="Data Inicio:" cols="12 6" >
                            <input type="text" class="input-date" name="date" v-model="novoTermo.dataInicioTermo" v-mask-date.br /> 
                        </Rotulo>
                        <Rotulo nome="Data Termino:" cols="12 6" >
                            <input type="text" class="input-date" name="date" v-model="novoTermo.dataTerminoTermo" v-mask-date.br />          
    
                        </Rotulo>
                        <Rotulo nome="Termo de aceite:" cols="12" >
                            <Editor v-model="novoTermo.infoTermo" editorStyle="height: 400px"/>
                        </Rotulo>
                    </div>
                </cadastro-rapido>

                  <!-- MODAL EDITAR TERMO -->
                <cadastro-rapido tituloTela="Editar Termo" tamanhoTela="800" v-model="exibirEditarTermo" 
                :modoEdicao="'alterar'"  :onAlterar="editarTermo">
                    <div class='p-grid p-fluid'>
                        <Rotulo nome="Descrição:" cols="12" >
                            <InputText type="text" v-model="novoTermo.descTermo" v-required  />
                        </Rotulo>
                        <Rotulo nome="Data Inicio:" cols="12 6" >
                            <input type="text" class="input-date" name="date" v-model="novoTermo.dataInicioTermo" v-mask-date.br />          
                              
                        </Rotulo>
                        <Rotulo nome="Data Termino:" cols="12 6" >
                            <input type="text" class="input-date" name="date" v-model="novoTermo.dataTerminoTermo" v-mask-date.br />          
     
                        </Rotulo>
                        <Rotulo nome="Termo de aceite:" cols="12" >
                            <Editor v-model="novoTermo.infoTermo" editorStyle="height: 400px"/>
                        </Rotulo>
                    </div>
                </cadastro-rapido>

              <!-- MODAL excluir TERMO -->
                <cadastro-rapido tituloTela="Excluir Termo" tamanhoTela="800" v-model="exibirExcluirTermo" 
                :modoEdicao="'excluir'"  :onAlterar="excluirTermo">
                    <div class='p-grid p-fluid'>
                        <Rotulo nome="Descrição:" cols="12" >
                            <InputText type="text" v-model="novoTermo.descTermo" disabled />
                        </Rotulo>
                    </div>
                </cadastro-rapido>

            </Fieldset>
        </div>
        <div class="p-col-12">              
            <Fieldset legend="Questionários">
                <div class="p-col-12 p-md-3 p-md-offset-7">                    
                    <Button label="Novo Questionário" icon="pi pi-check" class="p-button-rounded" @click="abrirNovoQuestionario()"/>
                </div>
                <div class="p-col-12 p-md-8 p-md-offset-2">
                    <table-seplag :dados.sync="questionarios" :exibirCabecalho="false" 
                    :paginacao="true" :loading="loadingPaginacaoQuestionario" :totalRegistro.sync="totalRegistroQuestionario" :urlPanagicao="urlPanagicaoQuestionario">  
                        <Column bodyStyle="text-align: center" header="#" :headerStyle="'width: 8em'">
                            <template #body="slotProps">                                     
                                <RadioButton :id="slotProps.data.idenQuestionario" :name="slotProps.data.idenQuestionario" :value="slotProps.data" v-model="cicloRecadastramento.questionario" />
                            </template>
                        </Column>
                        <Column header="Descrição">
                            <template #body="slotProps">                                     
                                    <span class="customer-badge-pentende"> {{slotProps.data.descQuestionario}}</span>
                            </template>
                        </Column>  
                         <Column>  
                          <template #body="slotProps"> 
                                    <Button v-if="slotProps.data.statCiclo!='FECHADO'" v-tooltip="'Editar'" icon="pi pi-pencil" class="p-button-rounded p-button-warning margin-botao" @click="editarQuestionario(slotProps.data)"/>
                        </template>                    
                         </Column>
                    </table-seplag>
                </div>
            </Fieldset>
        </div>
        <div class="p-col-12">              
            <Fieldset legend="Fases">
                <div class="p-col-12 p-md-8 p-md-offset-2">
                    <table-seplag :dados.sync="fases" :exibirCabecalho="false" 
                    :paginacao="true" :loading="loadingPaginacaoFases" :totalRegistro.sync="totalRegistroFases" :urlPanagicao="urlPanagicaoFases">  
                        <Column bodyStyle="text-align: center" header="#" :headerStyle="'width: 8em'">
                            <template #body="slotProps">                                     
                                <Checkbox  :id="slotProps.data.idenFase" :name="slotProps.data.descFase" :value="slotProps.data" v-model="cicloRecadastramento.fases" />
                            </template>
                        </Column>
                        <Column header="Descrição">
                            <template #body="slotProps">                                     
                                    <span class="customer-badge-pentende"> {{slotProps.data.descFase}}</span>
                            </template>
                        </Column>  
                    </table-seplag>
                </div>
            </Fieldset>
        </div>        
        <div class="p-col-12">              
            <Fieldset legend="Ciclo Referência">
                <div class="p-col-12 p-md-8 p-md-offset-2">
                    <table-seplag :dados.sync="ciclos" :exibirCabecalho="false" 
                    :paginacao="true" :loading="loadingPaginacaoCiclos" :totalRegistro.sync="totalRegistroCiclos" :urlPanagicao="urlPanagicaoCiclos">  
                        <Column bodyStyle="text-align: center" header="#" :headerStyle="'width: 8em'">
                            <template #body="slotProps">                                     
                                <RadioButton :id="slotProps.data.idenCiclo" :name="slotProps.data.descCiclo" :value="slotProps.data" v-model="cicloRecadastramento.idenCicloReferencia" />
                            </template>
                        </Column>
                        <Column header="Descrição">
                            <template #body="slotProps">                                     
                                    <span class="customer-badge-pentende"> {{slotProps.data.descCiclo}}</span>
                            </template>
                        </Column>    
                    </table-seplag>
                </div>
            </Fieldset>
        </div>
        <div class="p-col-12">
            <div class="p-grid p-fluid">
                <div class="p-col-12 p-md-3">
                    <Button label="Voltar" icon="pi pi-arrow-left" class="p-button-rounded" @click="listaCiclo()"/>
                </div>
                <div class="p-col-12 p-md-3" v-if="cicloRecadastramento.idenCiclo === undefined">
                    <Button label="Salvar" icon="pi pi-check" class="p-button-rounded p-button-success" @click="salvarCiclo()"/>
                </div>
                <div class="p-col-12 p-md-3" v-if="cicloRecadastramento.idenCiclo !== undefined">
                    <Button label="Editar" icon="pi pi-check" class="p-button-rounded p-button-warning" @click="editarCiclo()"/>
                </div>
            </div>
        </div>
    </card-seplag>    
</template>

<script>

import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import TableSeplag from '@/template/TableSeplag.vue'
import CadastroRapido from '@/template/CadRapidoSeplag.vue'
import { baseApiUrl } from '@/config/global'
/* import recadastramentoVue from '../recadastramento/recadastramento.vue'
 */
const getDefaultState = () => {
	return {
        fases: [],
        cicloReferencia: null,
        dataFinal: null,
        dataInicio: null,
        descCiclo: null,
        exercicio: null,
        questionario: null,
        termo: null
	}
}

export default {
    name: "gerenciaNovoCiclo",
    components: {CardSeplag,Rotulo,TableSeplag,CadastroRapido},
    data: function(){        
		return {
            exercicios: [],
            loadingPaginacaoExercicio: false,
            totalRegistroExercicio: 0,
            urlPanagicaoExercicio: '',

            fases: [],
            loadingPaginacaoFases: false,
            totalRegistroFases: 0,
            urlPanagicaoFases: '',
            
            questionarios: [],
            loadingPaginacaoQuestionario: false,
            totalRegistroQuestionario: 0,
            urlPanagicaoQuestionario: '',

            termos: [],
            loadingPaginacaoTermo: false,
            totalRegistroTermo: 0,
            urlPanagicaoTermo: '',
            exibirNovoTermo: false,
            exibirEditarTermo: false,
            exibirExcluirTermo: false,
            novoTermo:{
                descTermo: null,
                infoTermo: null,
                dataInicioTermo: null,
                dataTerminoTermo: null,
                flagTermoObrigatorio: 'S'

            },

            ciclos: [],
            loadingPaginacaoCiclos: false,
            totalRegistroCiclos: 0,
            urlPanagicaoCiclos: '',
            jsonCicloObJect: { exercicio: { idenExercicio: null},
                               termo: {idenTermo: null},
                               questionario: {idenQuestSistema: null, idenQuestionario: null},  
                               idenCicloReferencia: null,
                                dataInicio: "",
                                dataFinal: "",
                                statCiclo: "ABERTO",
                                descCiclo: " ",
                                idenCiclo: null,
                                fases: [ ]
                               },

            cicloRecadastramento:  getDefaultState(),
            questionarioSelecionado: null
        }
    },
    methods:{
         carregarDados(){     
           const sistema = this.$store.getters.getUser.contaAcesso.authorities.length > 0?  this.$store.getters.getUser.contaAcesso.authorities[0].sistema.idenSistema : null

           if(this.$store.getters.getCicloSelecionado){
               this.cicloRecadastramento =  JSON.parse(JSON.stringify(this.$store.getters.getCicloSelecionado))
           }else{
                this.cicloRecadastramento =  getDefaultState()
           }
             
           this.$http.get(`${baseApiUrl}/exercicios/desc`).then(res =>{
              this.exercicios = res.data
           })
           if(sistema){
                 this.$http.get(`${baseApiUrl}/questsistemas/sistema/ativos/${sistema}`).then(res =>{
                    this.questionarios = res.data
                   this.questionarios = this.questionarios.map((elementos) => {
                       return elementos.questionario
                    })
                })
           }else{
               this.$toast.add({severity:'error', summary: 'Erro ao carregar dados', detail: "Erro ao carregar o sistema do usuario", life: 6000})
           }  
           this.$http.get(`${baseApiUrl}/termos/ativos`).then(res =>{
              this.termos = res.data
           })
             
           this.$http.get(`${baseApiUrl}/fases/ativas`).then(res =>{
              this.fases = res.data
           })

           this.$http.get(`${baseApiUrl}/ciclos/status/FECHADO`).then(res =>{
              this.ciclos = res.data
           })
       },
    
       listaCiclo(){           
            this.$store.commit('setCicloSelecionado', null)
            this.$router.push({name:'listaCiclo'})
       },
       abrirNovoTermo(){
           this.exibirNovoTermo = true
           this.novoTermo = {
                descTermo: null,
                infoTermo: null,
                dataInicioTermo: null,
                dataTerminoTermo: null,
                flagTermoObrigatorio: 'S'
                }
       },

        abrirEditarTermo(data) {
            
              this.novoTermo = {
                  descTermo: data.descTermo,
                infoTermo: data.infoTermo,
                dataInicioTermo: data.dataInicioTermo,
                dataTerminoTermo: data.dataTerminoTermo,
                flagTermoObrigatorio: 'S'
                }
                           this.novoTermo.statTermo = "ATIVO";

                  this.novoTermo.idenTermo = data.idenTermo;
            this.exibirEditarTermo = true
       },
         abrirExcluirTermo(data){
           
            this.novoTermo = {
                  descTermo: data.descTermo,
                infoTermo: data.infoTermo,
                dataInicioTermo: data.dataInicioTermo,
                dataTerminoTermo: data.dataTerminoTermo,
                flagTermoObrigatorio: 'S'
                }
                           this.novoTermo.statTermo = "ATIVO";

                  this.novoTermo.idenTermo = data.idenTermo;
           this.exibirExcluirTermo = true
       },       
       criarNovoTermo(){
           this.novoTermo.statTermo = "ATIVO";
            this.$http.post(`${baseApiUrl}/termos`, JSON.stringify(this.novoTermo)).then(() =>{
               
               this.$toast.add({severity:'success', summary: 'Aviso', detail:'Termo criado com sucesso', life: 4000});

            })
          this.$http.get(`${baseApiUrl}/termos/ativos`).then(res =>{
              this.termos = res.data
           })
           this.cicloRecadastramento.termo = this.termos;
           this.$store.commit('setCicloSelecionado', this.cicloRecadastramento);    
           },
       editarTermo(){
             this.novoTermo.statTermo = "ATIVO";

            this.$http.put(`${baseApiUrl}/termos/${this.novoTermo.idenTermo}`, JSON.stringify(this.novoTermo)).then(() =>{
               
               this.$toast.add({severity:'success', summary: 'Aviso', detail:'Termo alterado com sucesso', life: 4000});

            })
               this.$http.get(`${baseApiUrl}/termos/ativos`).then(res =>{
              this.termos = res.data
           })
           this.cicloRecadastramento.termo = this.termos;
           this.$store.commit('setCicloSelecionado', this.cicloRecadastramento); 

       },
       excluirTermo(){        
           this.$http.delete(`${baseApiUrl}/termos/${this.novoTermo.idenTermo}`).then(() =>{
               
               this.$toast.add({severity:'success', summary: 'Aviso', detail:'Termo excluído com sucesso', life: 4000});

            })
              this.$http.get(`${baseApiUrl}/termos/ativos`).then(res =>{
              this.termos = res.data
           })
          // this.termos.push(this.novoTermo)
           this.cicloRecadastramento.termo = this.termos;
           this.$store.commit('setCicloSelecionado', this.cicloRecadastramento); 

       },
       abrirNovoQuestionario(){           
            this.$store.commit('setCicloSelecionado', this.cicloRecadastramento)
            this.$store.commit('setQuestionarioSelecionado',  { descQuestionario : " "})
            this.$store.commit('setPerguntasQuestionario', [])
              this.$store.commit("setNovasperguntaSelecionadasParaQuestionario", []);
            this.$router.push({name:'gerenciaNovoQuestionario'})
       },
       editarQuestionario(questionario){ 
            this.$store.commit('setQuestionarioSelecionado', questionario)
            this.$store.commit("setNovasperguntaSelecionadasParaQuestionario", []);
            this.$router.push({name:'gerenciaNovoQuestionario'});
            this.$toast.add({severity:'success', summary: 'Aviso', detail:'Ciclo alterado com sucesso', life: 4000});
       },
    salvarCiclo() {
        this.jsonCicloObJect.exercicio.idenExercicio = this.cicloRecadastramento.exercicio.idenExercicio;
        this.jsonCicloObJect.termo.idenTermo = this.cicloRecadastramento.termo.idenTermo;
        // this.jsonCicloObJect.questionario.idenQuestSistema  =  this.cicloRecadastramento.questionario.idenQuestSistema;
        this.jsonCicloObJect.questionario.idenQuestionario = this.cicloRecadastramento.questionario.idenQuestionario;
        this.jsonCicloObJect.idenCicloReferencia = this.cicloRecadastramento.idenCicloReferencia;
        this.jsonCicloObJect.dataInicio = this.cicloRecadastramento.dataInicio;
        this.jsonCicloObJect.dataFinal = this.cicloRecadastramento.dataFinal;
        this.jsonCicloObJect.descCiclo = this.cicloRecadastramento.descCiclo;
        this.cicloRecadastramento.fases.forEach(element => this.jsonCicloObJect.fases.push(element))
          this.$http.post(`${baseApiUrl}/ciclos`, JSON.stringify(this.jsonCicloObJect))
        .then(() => {
            this.$toast.add({severity:'success', summary: 'Aviso', detail:'Ciclo salvo com sucesso', life: 4000});

        }) 

    },
    editarCiclo() {
         this.jsonCicloObJect.exercicio.idenExercicio = this.cicloRecadastramento.exercicio.idenExercicio;
        this.jsonCicloObJect.termo.idenTermo = this.cicloRecadastramento.termo.idenTermo;
        // this.jsonCicloObJect.questionario.idenQuestSistema  =  this.cicloRecadastramento.idenQuestSistema;
        this.jsonCicloObJect.questionario.idenQuestionario = this.cicloRecadastramento.questionario.idenQuestionario;
        this.jsonCicloObJect.idenCicloReferencia = this.cicloRecadastramento.idenCicloReferencia;
        this.jsonCicloObJect.dataInicio = this.cicloRecadastramento.dataInicio;
        this.jsonCicloObJect.dataFinal = this.cicloRecadastramento.dataFinal;
        this.jsonCicloObJect.descCiclo = this.cicloRecadastramento.descCiclo;
        this.jsonCicloObJect.idenCiclo = this.cicloRecadastramento.idenCiclo;
        this.cicloRecadastramento.fases.forEach(element => this.jsonCicloObJect.fases.push(element));
        this.$http.put(`${baseApiUrl}/ciclos/${this.jsonCicloObJect.idenCiclo}`, JSON.stringify(this.jsonCicloObJect))
        .then(() => {
            this.$toast.add({severity:'success', summary: 'Aviso', detail:'Ciclo alterado com sucesso', life: 4000});

        }) 


    }
    },
    mounted(){        
        this.carregarDados()
    }

}
</script>

<style scoped>
  .input-date {
     font-size: 14px;
     height: 32px;
    color: #333333;
    background: #ffffff;
    padding: 0.300em;
    border: 1px solid #a6a6a6;
    -webkit-transition: border-color 0.2s, box-shadow 0.2s;
    transition: border-color 0.2s, box-shadow 0.2s;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 3px;
 }
</style>